import { ZipCodeValidation } from '../../../../shared/Form';

export class ZipCodeValidationFR extends ZipCodeValidation {
  constructor(errorMessage: string = 'Entered value is not a valid zip code') {
    super(/^\d{5}(\sCEDEX(\s\d{1,2})?)?$/i, errorMessage);
  }
}
